<template>
    <div class="table-list be-signed">
        <modal class="del-contract" :display="modalState.delContract" @modalStatus="closeModal()" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>刪除紙本合約</h1>
            <div class="content">
                確定要刪除“{{filterByWord.length?filterByWord[selected].address:''}}”的合約嗎？確定後將直接刪除此合約
            </div>
            <div class="btn-group">
                <button class="default-button" @click="delContract(filterByWord[selected].paperContractCid)">確認</button>
                <button class="border-button" @click="closeModal()">取消</button>
            </div>
        </modal>
        <div class="mask"></div>
        <div class="table-list-title">
            <span class="contract-date">租約起訖日</span>
            <span class="address">地址</span>
            <span class="status">租約狀態</span>
            <span class="tenant">租客</span>
            <span class="agent">業務</span>
            <span class="rent">租金</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-if="isLoading" class="filter-empty">
                <table-loading />
            </div>
            <div v-else-if="filterByWord.length == 0 && beSignedList.length != 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <button class="default-button" @click="setFilterDefault">清除篩選</button>
            </div>
            <div v-else-if="beSignedList.length == 0" class="is-empty">0 筆資料</div>
            <ul v-else>
                <li v-for="(house,index) in filterByWord" :key="index">
                    <span class="contract-date">{{getFormatDate(house.contractBeginTime)}} - {{getFormatDate(house.contractEndTime)}}</span>
                    <span class="address">
                        {{house.address}}
                        <!-- {{house.address.length >= 19?compressWord(house.address, 19):house.address}}
                        <div v-if="house.address.length >= 19" class="full-word">
                            <span>
                                {{house.address}}
                            </span>
                        </div> -->
                    </span>
                    <span class="status">
                        <span class="gray" v-if="house.paperContractStatus == 'NOTIFY_TENANT'">已通知</span>
                        <span class="red" v-if="house.paperContractStatus == 'UPLOAD_FILE' || house.paperContractStatus === 'CREATE_NEW_PAPER_CONTRACT' ">未通知</span>
                    </span>
                    <span class="tenant">{{house.tenantName}}</span>
                    <span class="agent">{{house.landlordName}}</span>
                    <span class="rent">{{toCurrency(house.rentPrice)}}</span>
                    <span class="action">
                        <dot-dropmenu>
                            <ul >
                                <!-- <li @click="toContractDetail(house.paperContractCid)">合約詳情</li> -->
                                <li @click="getContractPDF(house.paperContractCid), $analyticsBiz.logEvent('查看紙本合約', { screen_name: '查看紙本合約'})"
                                    >紙本合約</li>
                                <li v-if="house.paperContractStatus == 'UPLOAD_FILE' " @click="notifyTenant(house.paperContractCid),  $analyticsBiz.logEvent('通知租客', { screen_name: '通知租客'})">通知租客</li>
                                <li v-if="bizAuth.deletePaperContract.hasRight" @click="selected = index, modalState.delContract= true">刪除</li>
                                <!-- <li @click="setNewBill(), contractId = house.paperContractCid">新增費用</li> -->
                            </ul>
                        </dot-dropmenu> 
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';

import { mapGetters } from 'vuex'

import { 
    delPaperContract,
    getPaperContractPDF,
    paperContractNotification
    } from "@/apis/company/leaseMgt.js"; 
export default {
    data () {
        return {
            // beSignedList: [],
            filterEmpty: false,
            leaseDataEmpty: false,
            leaseDataError: false,
            isLoading: true,
            contractId: null,
            selected: 0,
            modalState: {
                delContract: false
            }
        }
    },
    mounted () {
        this.getLeaseBeSignedList()
        console.log(this.$route.query)
        // if( this.$route.query.success && this.$route.query.success == 1){
        //     this.alart.success = true
        //     this.msg.success = '已建立紙本合約'
        //     if(this.$route.query.type && this.$route.query.type == 1){
        //         this.msg.successDes = '您尚未通知房客，可以另外通知房客進行合約確認'
        //     }
        //     if(this.$route.query.type && this.$route.query.type == 2){
        //         this.msg.successDes = '飛豬管家已發送簡訊通知房客進行合約確認，您也可以主動通知房客'
        //     }
        //     this.$router.replace('bussiness/leaseMgt/')
        // }
    },
    methods: {
        getLeaseBeSignedList: function () {
            this.isLoading = true
            this.loadLeaseBeSignedPage(1)
        },
        // 逐頁抓取並累加：第 1 頁一到就先顯示，其餘頁在背景繼續載入並自動接上
        // 有 totalPage 就照總頁數抓；純陣列(未知總頁數)則抓到某頁回空為止，上限 100 頁避免無限迴圈
        loadLeaseBeSignedPage: function (page) {
            this.$store.dispatch('getBizLeaseBeSignedMgtList', page)
            .then((info)=>{
                // 第一頁回來就關掉 loading，先讓使用者看到資料
                if( page === 1 ){
                    this.isLoading = false
                }
                let hasMore = info.totalPage > 0
                    ? page < info.totalPage
                    : (info.count > 0 && page < 100)
                if( hasMore ){
                    this.loadLeaseBeSignedPage(page + 1)
                }
            })
            // apiBizGetLeaseBeSigned()
            // .then( res => {
            //     console.log(res)
            //     if(res.data.status == 'SUCCESS'){
            //         if( res.data.result.length > 0){
            //             this.beSignedList = res.data.result
            //             this.isLoading = false
            //         }else{
            //             this.leaseDataEmpty = true
            //         }
            //     }
            // })
            // .catch( err => {
            //     console.log(err)
            // })
        },
        closeModal: function () {
            this.modalState.delContract = false
        },
        delContract: function (cid) {
            let data = {
                paperContractCid: cid
            }
            delPaperContract(data).then( res => {
                if( res.data.status == "SUCCESS" ){
                    this.closeModal()
                    this.getLeaseBeSignedList()
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '刪除合約成功',type: 'success'})
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch( err => {
                this.$store.dispatch('setAlarmStatus', {status: true,title: err,type: 'error'})
            })
        },
        getContract: function (cid) {
            window.open('/contractPaper?cid='+cid, "_blank")
        },
        getContractPDF: function (cid) {
            const params = {
                paperContractCid: cid
            }
            getPaperContractPDF(params)
            .then( res => {
                console.log(res)
                if(res.status == 200){
                //    window.open(res.data);
                    // var blob = new Blob([res.data], { type: 'application/pdf' });
                    //    window.open(res.data);
                    // var blob = new Blob([res.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf;charset-UTF-8' }));
                    window.open(url);
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        setFilterDefault: function () {
            this.$store.dispatch('setBizLeaseBeSignedFilterDefault')
        },
        // toContractDetail: function (cid) {
        //     window.open('/landlord/leasemanagement/contractdetail?cid='+cid)
        // },
        setNewBill: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizNewBill'})
        },
        notifyTenant: function (cid) {
            let data = {
                paperContractCid: cid
            }
            paperContractNotification(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '通知訊息已送出',type: 'success'})
                    this.getLeaseBeSignedList()
                    resolve()
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                reject(err)
            })
        },
        getFormatDate: function (date){
            var formatDate = [];
            var date = new Date(date);
            // var date = new Date(Date.parse(date));
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
            // return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6]+' '+formatDate[3]+':'+formatDate[4];
        },
    },
    computed: {
        fileterByCounty: function () {
            return this.beSignedList.filter((item) => {
                if(this.filterQuery.county){
                    if(item.county.includes(this.filterQuery.county) == true){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        fileterByDistrict: function () {
            return this.fileterByCounty.filter((item) => {
                if( this.filterQuery.district){
                    if(item.district.includes(this.filterQuery.district) == true){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByRent: function () {
            return this.fileterByDistrict.filter((item) => {
                if( this.filterQuery.rent ){
                    if( this.filterQuery.rent[0] <= item.rentPrice && this.filterQuery.rent[1] >= item.rentPrice ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByContractDate: function () {
            return this.filterByRent.filter((item) => {
                // console.log(item)
                if( this.filterQuery.leaseTerm[0] && this.filterQuery.leaseTerm[1] ){
                    let rentDateStart = Date.parse(item.contractBeginTime).valueOf(),
                        rentDateEnd = Date.parse(item.contractEndTime).valueOf(),
                        filterRentDateStart = Date.parse(this.filterQuery.leaseTerm[0]).valueOf(),
                        filterRentDateEnd = Date.parse(this.filterQuery.leaseTerm[1]).valueOf()
                        
                    if( filterRentDateStart <= rentDateStart && rentDateEnd <= filterRentDateEnd ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByGroup: function () {
            return this.filterByContractDate.filter((item) => {
                if(this.filterQuery.group){
                    if(item.groupName == this.filterQuery.group ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterBySales: function () {
            return this.filterByGroup.filter((item) => {
                if(this.filterQuery.member){
                    if(item.landlordName == this.filterQuery.member ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByStatus: function () {
            return this.filterBySales.filter((item) => {
                if(this.filterQuery.status){
                    if(item.paperContractStatus == this.filterQuery.status ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByWord: function () {
            return this.filterByStatus.filter((beSignedItem) => {
                if( this.filterWord ){
                    if( beSignedItem.tenantName.includes(this.filterWord) || beSignedItem.address.includes(this.filterWord) || beSignedItem.tenantPhone.includes(this.filterWord) ){
                        return beSignedItem
                    }
                }else{
                    return beSignedItem
                }
            });
        },
        ...mapGetters({
            beSignedList: 'GET_BIZ_LEASE_BE_SIGNED_MGT_LIST',
            totalPage: 'GET_BIZ_LEASE_BE_SIGNED_MGT_TOTAL_PAGE',
            filterWord: 'GET_BIZ_LEASE_BE_SIGNED_MGT_FILTER_WORD',
            filterQuery: 'GET_BIZ_LEASE_BE_SIGNED_MGT_FILTER_QUERY',
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        'dot-dropmenu': DotDropMenu,
        Modal,
        AlartMsg,
        tableLoading,
    }
}
</script>
<style lang="scss">
        .table-list.be-signed{
        // .table-list-title .contract-date:before{
        //     content: '';
        //     position: absolute;
        //     width: 0;
        //     height: 0;
        //     left: 66px;
        //     top: 2px;
        //     border-style: solid;
        //     border-width: 0 2.5px 4px 2.5px;
        //     border-color: transparent transparent #525956 transparent;
        // }
        // .table-list-title .contract-date:after{
        //     content: '';
        //     position: absolute;
        //     width: 0;
        //     height: 0;
        //     left: 66px;
        //     bottom: 1px;
        //     border-style: solid;
        //     border-width: 4px 2.5px 0 2.5px;
        //     border-color: #525956 transparent transparent transparent;
        // }
        .table-list-title .contract-date,
        .table-list-body ul li .contract-date{
            position: relative;
            width: 160px;
            margin-right: 71px;
        }
        .table-list-title .address,
        .table-list-body ul li .address{
            width: 248px;
            margin-right: 71px;
        }
        .table-list-body ul li .address{
            line-height: 1.5;
        }
        .table-list-title .status,
        .table-list-body ul li .status{
            width: 76px;
            margin-right: 71px;
        }
        .table-list-body ul li .status{
            >span{
                width: 76px;
                height: 38px;
                border-radius: 4px;
                font-weight: 500;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .red{
                background-color: rgba(255, 146, 117, 0.1);
                color: #fc7171;
            }
            .gray{
                background-color: #f3f3f3;
                color: #676362;
            }
            .blue{
                background-color: rgba(79, 181, 192, 0.08);
                color: #71aae5;
            }
        }
        .table-list-title .tenant,
        .table-list-body ul li .tenant{
            width: 42px;
            margin-right: 71px;
            word-break: break-all;
        }
        .table-list-title .agent,
        .table-list-body ul li .agent{
            width: 42px;
            margin-right: 71px;
        }
        .table-list-title .rent,
        .table-list-body ul li .rent{
            text-align: right;
            width: 51px;
            margin-right: 71px;
        }
       
    }
    #modal.del-contract{
        .modal-content{
            padding: 0 !important;
            .alarm-img{
                margin-top: 40px;
            }
            h1{
                font-size: 24px;
                margin-top: 12px;
                margin-bottom: 16px;
            }
            .content{
                padding: 0 40px;
                width: 368px;
                line-height: 1.57;
                color: #a8a5a4;
                text-align: center;
                margin-bottom: 50px;
            }
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 184px;
                    height: 44px;
                }
                button:first-child{
                    margin-right: 14px;
                }
            }
        }
    }
    // @media screen and (max-width: 1280px){
    //     .table-list.be-signed{
    //         .table-list-title .contract-date,
    //         .table-list-body ul li .contract-date{
    //             margin-right: 40px;
    //         }
    //         .table-list-title .tanant,
    //         .table-list-body ul li .tanant{
    //             margin-right: 60px;
    //         }
    //         .table-list-title .phone,
    //         .table-list-body ul li .phone{
    //             margin-right: 65px;
    //         }
    //     }
    
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/leaseMgt/leaseBeSigned/LeaseBeSignedList.vue